<template>
  <div>
    <div
      class="flex flex-col justify-between gap-4 lg:flex-row lg:gap-0"
      :class="[methodologyFileInfo ? 'items-center' : 'items-start']"
    >
      <div
        class="flex w-fit grow gap-4 md:items-center"
        data-testid="icon-title"
      >
        <Icon v-if="icon" class="h-[50px] w-[50px]" :name="icon" />

        <h1
          class="text-3xl font-bold text-s-900 first-letter:capitalize md:text-4xl"
          :class="titleClasses"
        >
          {{ title }}
        </h1>
      </div>
      <SummaryDownloadButton
        :methodology-file-info="methodologyFileInfo"
        class="w-[200px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/common/Icon.vue'
import SummaryDownloadButton from '~/components/price-assessments/SummaryDownloadButton.vue'
import type { TDownloadFile } from '~/types/benchmark-app.type'

withDefaults(
  defineProps<{
    title: string
    icon: string
    methodologyFileInfo?: TDownloadFile
    titleClasses?: string
  }>(),
  {
    methodologyFileInfo: null,
    titleClasses: '',
  },
)
</script>
